<div>
      <div class="spike-card items-center mb-4">
            <p-stepper [value]="stateId()" class="basis-[100rem]"  [linear]="true">
                  <p-step-list>
                        @for (item of workflow(); track $index) {
                              @if(item.id){
                              <p-step [value]="item.id">{{item.label}}</p-step>
                              }
                        }
                  </p-step-list>
            </p-stepper>
      </div>
      <div class="flex justify-end mb-4">
            <ng-content></ng-content>
      </div>
</div>